import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { ReleaseNoteForm } from '../../../../../../shared/models/release-notes.models';
import { AdminButtonComponent } from '../../../../../../shared/admin';
import { ReleaseUpdateListComponent } from '../release-update-card/release-update-card.component';

@Component({
  selector: 'app-release-form',
  standalone: true,
  imports: [FormsModule, AdminButtonComponent, ReleaseUpdateListComponent],
  templateUrl: './release-form.component.html',
  styleUrl: './release-form.component.scss',
})
export class ReleaseFormComponent {
  readonly form = input.required<ReleaseNoteForm>();
  readonly saving = input(false);
  readonly error = input<string | null>(null);

  readonly formChange = output<ReleaseNoteForm>();
  readonly save = output<void>();
  readonly cancel = output<void>();

  patch(patch: Partial<ReleaseNoteForm>): void {
    this.formChange.emit({ ...this.form(), ...patch });
  }
}
